export const SHOW_BANNER_IN_CALL_DISTRIBUTION = 'showBannerInCallDistribution';
